import React from 'react';
import { getPartnerKey } from 'src/utils/getGlobalPartnerKey';

import Midkingz from './midkingz.png';
import { LOGO } from 'src/constants/logos';

type PartnerLogoType = {
    width: number;
    height: number;
};

const PartnerLogo = ({
    width,
    height
}: Partial<PartnerLogoType>): JSX.Element => {
    const partnerKey = getPartnerKey();
    let logoSrc;

    switch (partnerKey) {
        case 'midkingz':
            logoSrc = Midkingz;
            break;
        default:
            logoSrc = LOGO.TRANSPARENT;
            break;
    }

    return <img width={width} height={height} src={logoSrc} alt="logo" />;
};

export default PartnerLogo;
